import { useEffect, useState } from 'react';
import { SectionWrapper } from '../../../../components/ui/SectionWrapper';
import { useLanguage } from '../../../../context/LanguageContext';
import { FurtherTraining } from '../../../../models/further-training.interface';
import { furtherTrainingService } from '../../../../services/further-training.service';

export function FurtherTrainingSection() {
    const { lang, t } = useLanguage();
    const [training, setTraining] = useState<FurtherTraining[]>([]);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        setTraining(furtherTrainingService.getTraining());
    }, []);

    const visible = showAll ? training : training.slice(0, 4);

    return (
        <SectionWrapper id="training" title={t('section.training')}>
            <div className="space-y-3">
                {visible.map(item => (
                    <div key={item.id} className="flex items-start gap-3 p-3 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                        <span className="shrink-0 text-sm font-mono font-medium text-blue-600 dark:text-blue-400 w-12 pt-0.5">
                            {item.year}
                        </span>
                        <div>
                            <p className="font-medium text-slate-900 dark:text-white">
                                {item.name[lang]}
                            </p>
                            <p className="text-sm text-slate-500 dark:text-slate-400">
                                {item.institution}
                                {item.location && ` · ${item.location}`}
                                {item.hours && ` · ${item.hours}${t('label.hours')}`}
                            </p>
                        </div>
                    </div>
                ))}
            </div>

            {training.length > 4 && (
                <button
                    onClick={() => setShowAll(!showAll)}
                    className="mt-6 text-sm font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
                >
                    {showAll ? t('label.showLess') : t('label.showAll')} ({training.length})
                </button>
            )}
        </SectionWrapper>
    );
}
